import React from 'react';
import './OverViewCorporateBlock.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function OverViewCorporateBlock({ fields }) {
  return (
    <div className={'container over-view-corporate'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'titleContainer'}>
          <h2 className={'titleContainer_title'}>{fields?.title?.value}</h2>
        </div>
        <p className={'text'}>{fields?.desc?.value}</p>
      </div>
      <div className={'imageContainer'} data-aos="fade-up">
        <div className={'imageContainer_image'}>
          <Image field={fields?.image} alt="Car" />
        </div>
      </div>
    </div>
  );
}
